type DriverPlanningsTime = {
  hours: number;
  minutes: number;
};

export const getStartTimeAndEndTimeFromExcel = (
  year: string,
  month: string,
  day: string,
  planningStartTime: DriverPlanningsTime,
  planningEndTime: DriverPlanningsTime,
) => {
  const planningDate = new Date(
    parseInt(year),
    parseInt(month) - 1,
    parseInt(day),
    12,
    0,
    0,
  );

  const startTime = new Date(planningDate);
  startTime.setHours(planningStartTime.hours, planningStartTime.minutes, 0, 0);

  const endTime = new Date(planningDate);
  endTime.setHours(planningEndTime.hours, planningEndTime.minutes, 0, 0);

  if (endTime < startTime) {
    endTime.setDate(endTime.getDate() + 1);
  }
  return {
    startTime: startTime.toISOString(),
    endTime: endTime.toISOString(),
  };
};
